export const bumexFeaturesKeys = {
  ENABLED_CONTACT_DATA_MODAL: 'ENABLED_CONTACT_DATA_MODAL',
  ENABLE_COUNTRY_CODE_INPUT: 'ENABLE_COUNTRY_CODE_INPUT',
  FEEDBACK_NOTIFICATION: 'FEEDBACK_NOTIFICATION',
  ENABLE_PANEL_MICROSITIO_V2: 'ENABLE_PANEL_MICROSITIO_V2',
  ENABLED_CHECK_UNREAD_LEADS: 'ENABLED_CHECK_UNREAD_LEADS',
  VA_TOUR_ESTADISTICAS: 'VA_TOUR_ESTADISTICAS',
  ESTADISTICAS_REPUTACION: 'ESTADISTICAS_REPUTACION',
  NEW_THANKS_VIEW: 'NEW_THANKS_VIEW',
  NEWDESIGN_ACIVITY_CONTACTED: 'NEWDESIGN_ACIVITY_CONTACTED',
  NEW_REPUTATION_SECTION: 'NEW_REPUTATION_SECTION',
  SHOW_BANNER_TO_OLD_PUB: 'SHOW_BANNER_TO_OLD_PUB',
  NEW_REALESTATE_PRO_PUBLISHER_ENABLE: 'NEW_REALESTATE_PRO_PUBLISHER_ENABLE',
  NOW_PUBLISHER_FLOW_DEVELOPMENTS_DISABLED: 'NOW_PUBLISHER_FLOW_DEVELOPMENTS_DISABLED'
};
